import {
  BiddableListing,
  IMAGE_VARIANT,
  SUPPORTED_MIME_IMAGE_FORMATS,
  useGetImageUrl,
} from '@frontend/api';
import { formatNumberToUS } from '@frontend/utils';
import { Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { useIntl } from 'react-intl';
import {
  BiddableListingDescriptionWrapper,
  BiddableListingDetailsDataItemListWrapper,
  BiddableListingDetailsHeadingWrapper,
  BiddableListingDetailsWrapper,
} from './BiddableListingDetails.css';
import { RiArrowUpDownLine } from '@remixicon/react';
import { RiRecycleLine } from '@remixicon/react';
import { useMemo } from 'react';
import { Carousel, Chip } from '@frontend/ui-elements';

const BiddableListingCard = ({
  uuid,
  publicId,
  metalType,
  isriGrade,
  quantity,
  productImages,
  productDescription,
}: BiddableListing) => {
  const intl = useIntl();
  const { getImageUrl } = useGetImageUrl();

  const imageUrls = useMemo(() => {
    if (!productImages?.length) return [];

    const supported = new Set(Object.keys(SUPPORTED_MIME_IMAGE_FORMATS));

    return productImages
      .filter(img => supported.has(img.fileType))
      .map(img =>
        getImageUrl(uuid, img.uniqueIdentifier, IMAGE_VARIANT.BIDDING),
      );
  }, [productImages, getImageUrl, uuid]);

  const readableMetalType = capitalize(
    intl.formatMessage({
      id: `customer-platform.api.${metalType}`,
      defaultMessage: '-',
    }),
  );

  return (
    <BiddableListingDetailsWrapper>
      <Carousel
        id={`biddable-listing-card-carousel.${uuid}`}
        images={[...imageUrls]}
        caption={productDescription ?? readableMetalType}
        width="100%"
        height="248px"
      ></Carousel>
      <BiddableListingDescriptionWrapper>
        <BiddableListingDetailsHeadingWrapper>
          <Typography variant="h5">{readableMetalType}</Typography>
          <Typography variant="p3">
            {intl.formatMessage({
              id: 'customer-platform.bidding.biddable-listing-card.data-item.listing-id',
              defaultMessage: '-',
            })}{' '}
            {publicId}
          </Typography>
        </BiddableListingDetailsHeadingWrapper>
        <BiddableListingDetailsDataItemListWrapper>
          <Chip
            label={`${formatNumberToUS(quantity)} ${intl.formatMessage({ id: 'customer-platform.bidding.biddable-listing-card.data-item.weight-unit' })}`}
            icon={<RiArrowUpDownLine size={14} />}
          />
          {isriGrade && (
            <Chip
              label={intl.formatMessage({
                id: `customer-platform.api.${isriGrade}`,
              })}
              icon={<RiRecycleLine size={14} />}
            />
          )}
        </BiddableListingDetailsDataItemListWrapper>
      </BiddableListingDescriptionWrapper>
    </BiddableListingDetailsWrapper>
  );
};

export default BiddableListingCard;
